/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseImageFieldType } from './DatabaseImageFieldType';
import {
    DatabaseImageFieldTypeFromJSON,
    DatabaseImageFieldTypeFromJSONTyped,
    DatabaseImageFieldTypeToJSON,
} from './DatabaseImageFieldType';

/**
 * 
 * @export
 * @interface DatabaseImageField
 */
export interface DatabaseImageField extends DatabaseField {
    /**
     * 
     * @type {DatabaseImageFieldType}
     * @memberof DatabaseImageField
     */
    type?: DatabaseImageFieldType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImageField
     */
    urlSourceFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImageField
     */
    categorySourceFieldId?: string;
}

/**
 * Check if a given object implements the DatabaseImageField interface.
 */
export function instanceOfDatabaseImageField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseImageFieldFromJSON(json: any): DatabaseImageField {
    return DatabaseImageFieldFromJSONTyped(json, false);
}

export function DatabaseImageFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseImageFieldTypeFromJSON(json['type']),
        'urlSourceFieldId': !exists(json, 'urlSourceFieldId') ? undefined : json['urlSourceFieldId'],
        'categorySourceFieldId': !exists(json, 'categorySourceFieldId') ? undefined : json['categorySourceFieldId'],
    };
}

export function DatabaseImageFieldToJSON(value?: DatabaseImageField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabaseImageFieldTypeToJSON(value.type),
        'urlSourceFieldId': value.urlSourceFieldId,
        'categorySourceFieldId': value.categorySourceFieldId,
    };
}

